export const iconFontAwesomeWeatherWind = (
	<i className="fa-solid fa-wind"></i>
);
